import LocaleProvider from "./LocaleContext";

export default LocaleProvider;
